import React from "react";
import {
  Box,
  Chip,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { DeleteButton } from "../../atoms/EditButton";

function formatDate(value) {
  if (!value) return "—";
  const date =
    typeof value.toDate === "function" ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString();
}

const APIKeyList = ({ snapshot, onRevoke, onDeleteLegacy, onCopy }) => {
  if (!snapshot || snapshot.length === 0) {
    return (
      <Box
        style={{
          marginBottom: 12,
          maxHeight: 400,
          width: "100%",
          overflow: "auto",
        }}
      >
        <Typography>No API keys found</Typography>
      </Box>
    );
  }

  return (
    <Box
      style={{
        marginBottom: 12,
        maxHeight: 480,
        width: "100%",
        overflow: "auto",
      }}
    >
      {snapshot.map((doc) => {
        const isRevoked = doc.status === "revoked";
        const isLegacy = doc.isLegacy;

        return (
          <Box key={doc.id} style={{ marginBottom: 12 }}>
            <Grid container alignItems="center" justifyContent="space-between" spacing={1}>
              <Grid item xs={12} md={8}>
                <Stack spacing={0.5}>
                  <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                    <Typography component="code" sx={{ wordBreak: "break-all" }}>
                      {doc.displayKey}
                    </Typography>
                    {isLegacy ? (
                      <Chip size="small" label="Legacy" variant="outlined" />
                    ) : (
                      <Chip size="small" label="m45" color="secondary" variant="outlined" />
                    )}
                    <Chip
                      size="small"
                      label={isRevoked ? "Revoked" : doc.status || "active"}
                      color={isRevoked ? "default" : "success"}
                    />
                  </Stack>
                  <Typography variant="body2" color="text.secondary">
                    {doc.label || "API key"} · Created {formatDate(doc.createdAt)}
                    {isLegacy
                      ? ""
                      : doc.expiresAt
                        ? ` · Expires ${formatDate(doc.expiresAt)}`
                        : " · Never expires"}
                    {doc.lastUsedAt ? ` · Last used ${formatDate(doc.lastUsedAt)}` : ""}
                  </Typography>
                </Stack>
              </Grid>
              <Grid item>
                <Stack direction="row" spacing={0.5}>
                  {isLegacy && doc.key && onCopy ? (
                    <Tooltip title="Copy legacy key">
                      <IconButton
                        size="small"
                        onClick={() => onCopy(doc.key)}
                        aria-label="Copy legacy API key"
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  ) : null}
                  {isLegacy ? (
                    <DeleteButton
                      onClick={() => {
                        if (onDeleteLegacy) onDeleteLegacy(doc.id);
                      }}
                    />
                  ) : !isRevoked ? (
                    <DeleteButton
                      onClick={() => {
                        if (onRevoke) onRevoke(doc.id);
                      }}
                    />
                  ) : null}
                </Stack>
              </Grid>
            </Grid>
          </Box>
        );
      })}
    </Box>
  );
};

export default APIKeyList;
